import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { motion, useReducedMotion } from 'framer-motion';
import * as React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  placeholder: {
    background: theme.palette.black[50],
    borderRadius: theme.pxToRem(4),
  },
}));

interface PlotContainerProps {
  className?: string;
  isLoading?: boolean;
}

export const PlotContainer: React.FC<PlotContainerProps> = ({
  className,
  children,
  isLoading = false,
  ...restProps
}) => {
  const classes = useStyles({});

  const shouldReduceMotion = useReducedMotion();

  if (isLoading) {
    return (
      <Box
        className={clsx(classes.root, classes.placeholder, className)}
        justify="center"
        align="center"
        fullHeight
        fullWidth
      >
        <DotLoader size={1} />
      </Box>
    );
  }

  return (
    <motion.div
      className={clsx(classes.root, className)}
      initial={shouldReduceMotion ? { opacity: 0 } : { opacity: 0, x: 16 }}
      animate={
        shouldReduceMotion
          ? { opacity: 1 }
          : { opacity: 1, x: 0, transition: { duration: 0.3, ease: 'easeIn' } }
      }
      {...restProps}
    >
      {children}
    </motion.div>
  );
};
